import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum.js';
import TpDataExportExcludedItemSearchParams from './TpDataExportExcludedItemSearchParams.js';
import TpDataExportExcludedItem from '../../../Domain/TpDataExportExcludedItem.js';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable.js';
import TpDataExportExcludedItemService from '../../../Services/TpDataExportExcludedItemService.js';
import ErrorMessage from '../../../Elements/ErrorMessage.js';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow.js';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum.js';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum.js';
import IconPositionEnum from '../../../Enums/IconPositionEnum.js';

export default class TpDataExportExcludedItemAdmin extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    TpDataExportExcludedItem.ignoreFunction = (id, item) => this.ignoreFunctionApprove(id, item);
    TpDataExportExcludedItem.activateFunction = (id, item) => this.activateFunctionApprove(id, item);
    TpDataExportExcludedItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
    TpDataExportExcludedItem.selectedStatus = this.selectedStatus.bind(this);
    TpDataExportExcludedItem.clickOnSelect = this.clickOnSelect.bind(this);

    this.state = {
      searchItem: new TpDataExportExcludedItemSearchParams(),
      itemList: [],
      selectedItem: null,
      shownPanel: ShownPanelsEnum.None,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.panelOnClose = this.panelOnClose.bind(this);
  }

  clickOnSelect(item, selected) {
    item.Selected = selected;
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      if (element.TpDataExportExcludedItemId === item.TpDataExportExcludedItemId) {
        element.Selected = selected;
      }
    });
    this.setState({ itemList: templist });
  }

  selectAllElements() {
    const selectedStatus = this.state.itemList.some((item) => item.Selected === false);

    const templist = [...this.state.itemList];

    if (templist !== undefined && templist.length > 0) {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    this.setState({ itemList: templist });
  }

  selectedStatus() {
    return !this.state.itemList.some((x) => x.Selected === false);
  }

  ignoreFunctionApprove(id, item) {
    if (item.Status === 'Active') {
      ErrorMessage.SetApprove(
        <span>
          You will ignore this Excluded Element: {item.TpDataExportExcludedItemId}
          <br />
          Type: {item.EntityType}, EntityId: {item.EntityId} <br />
          Are you sure?
        </span>,
        () => this.ignoreFunction(item.TpDataExportExcludedItemId)
      );
    }
  }

  ignoreFunction(id) {
    TpDataExportExcludedItemService.IgnoreItem(id)
      .then(() => this.refresh())
      .catch(() => ErrorMessage.SetErrorMessage('TDEEA44'));
  }

  activateFunctionApprove(id, item) {
    if (item.Status === 'Ignored') {
      ErrorMessage.SetApprove(
        <span>
          You will activate this Excluded Element: {item.TpDataExportExcludedItemId}
          <br />
          Type: {item.EntityType}, EntityId: {item.EntityId} <br />
          Are you sure?
        </span>,
        () => this.activateFunction(item.TpDataExportExcludedItemId)
      );
    }
  }

  activateFunction(id) {
    TpDataExportExcludedItemService.ActivateItem(id)
      .then(() => this.refresh())
      .catch(() => ErrorMessage.SetErrorMessage('TDEEA65'));
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  panelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  clickOnBulkStatusChangeApprove(newStatus) {
    ErrorMessage.SetApprove(
      <span>
        You will change the status of the selected items to {newStatus}:
        <br />
        Are you sure?
      </span>,
      () => this.clickOnBulkStatusChange(newStatus)
    );
  }

  clickOnBulkStatusChange(newStatus) {
    const selectedItems = this.state.itemList.filter((x) => x.Selected === true);
    const selectedIds = selectedItems.map((x) => x.TpDataExportExcludedItemId);
    TpDataExportExcludedItemService.BulkStatusChange(selectedIds, newStatus)
      .then(() => this.refresh())
      .catch(() => ErrorMessage.SetErrorMessage('TDEEA65'));
  }

  renderButtons() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              iconName: 'fa-regular fa-toggle-on',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnBulkStatusChangeApprove('Active'),
              tooltip: 'Activate',
              disabled: !this.state.itemList.some((x) => x.Selected === true && x.Status === 'Ignored'),
            },
            {
              iconName: 'fa-regular fa-toggle-off',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnBulkStatusChangeApprove('Ignored'),
              tooltip: 'Ignore',
              disabled: !this.state.itemList.some((x) => x.Selected === true && x.Status === 'Active'),
            },
          ]}
        />
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtons()}
        <TabOfDataTable
          clickOnStartSearch={this.startSearch}
          searchParamsType={TpDataExportExcludedItemSearchParams}
          searchItem={this.state.searchItem}
          showSearchStrip={true}
          serviceFunction={TpDataExportExcludedItemService.GetAllItemBySearching}
          convertDBItemsFunction={TpDataExportExcludedItemService.ConvertDBItems}
          shownPanel={this.state.shownPanel}
          type={TpDataExportExcludedItem}
          popupEnabled={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in name, code...'
          errorCode='TEEIA83'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
        />
      </div>
    );
  }
}
